export enum TransitionClassNames {
  transition = 'transition',
  enter = 'enter',
  leave = 'leave',
  start = 'start',
  finish = 'finish',
}
